<script setup lang="ts">
interface ActivityDescriptionMarkdownStyles {
  openingParagraph: boolean;
}

const props = defineProps<ActivityDescriptionMarkdownStyles>();
</script>

<template>
  <div
    class="markdown-styles"
    :class="{ 'opening-paragraph': props.openingParagraph }"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
.markdown-styles {
  @include font-body-l-light;
  color: var(--color-neutral-70);
  margin: var(--spacing-16) 0;

  :deep(h3) {
    @include font-label-l-bold;
    color: var(--color-neutral-70);
    margin-top: var(--spacing-32);
    margin-bottom: var(--spacing-16);
  }

  :deep(p) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }

  :deep(div) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }

  :deep(ul) {
    padding-left: var(--spacing-32);
    margin: var(--spacing-32) 0;
  }

  :deep(li) {
    @include font-body-l-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-16) 0;
  }

  &.opening-paragraph {
    :deep(ul) {
      list-style: none;
      padding-left: var(--spacing-8);
      margin: var(--spacing-32) 0;
    }

    :deep(ul li:before) {
      content: '✓';
      position: relative;
      left: calc(var(--spacing-8) * -1);
    }

    :deep(p) {
      margin-top: var(--spacing-16);
      margin-bottom: var(--spacing-32);
    }
  }
}
</style>
